export const simTariffs = [
  { value: "T1_5MB_EU", label: "T1_5MB_EU (Telefonica)" },
  { value: "T2_15MB_EU", label: "T2_15MB_EU (Telefonica)" },
  { value: "T3_5MB_NZ", label: "T3_5MB_NZ (Telefonica)" },
  { value: "T4_5MB_AUS", label: "T4_5MB_AUS (Telefonica)" },
  { value: "T5_10MB_TH", label: "T5_10MB_TH (Telefonica)" },
  { value: "T6_1024", label: "T6_1024 (Telefonica)" },
  { value: "MB_EU", label: "MB_EU (Telefonica)" },
  { value: "T7_DYN_EU", label: "T7_DYN_EU (Telefonica)" },
  { value: "sigfox", label: "Sigfox" },
  { value: "other", label: "other" },
];

export const simStatuses = [
  { value: "deactivated", label: "deactivated" },
  { value: "active", label: "active" },
];
